export default {
  withdraw: {
    title: 'Keluarkan',
    subtitle: 'Pantas, selamat dan mudah',
    secureEncrypted: 'Selamat dan Disulitkan',
    fiatOrCash: 'Fiat/Tunai',
    processing: 'Memproses...',
    select: 'Pilih',
    withdrawCurrency: 'Mata Wang Pengeluaran',
    chooseNetwork: 'Pilih Rangkaian',
    channel: 'Saluran',
    withdrawalAddress: 'Alamat Pengeluaran',
    pixKeyType: 'Jenis Kunci PIX',
    accountNumber: 'Nombor Akaun',
    enterAccountNumber: 'Sila masukkan nombor akaun anda',
    accountName: 'Nama Akaun',
    enterAccountName: 'Sila masukkan nama pemilik akaun',
    pixKey: 'Kunci PIX',
    enterPixKey: 'Sila masukkan kunci PIX anda',
    cpf: 'CPF',
    enterCpf: 'Sila masukkan CPF',
    bankName: 'Nama Bank',
    enterBankName: 'Sila masukkan nama bank',
    branch: 'Cawangan',
    enterBranch: 'Sila masukkan cawangan (pilihan)',
    phone: 'Telefon',
    enterPhone: 'Sila masukkan telefon (pilihan)',
    email: 'E-mel',
    enterEmail: 'Sila masukkan e-mel (pilihan)',
    available: 'Boleh dikeluarkan',
    amountPlaceholder: 'Jumlah ({unit})',
    min: 'Min',
    max: 'Maks',
    totalWithdrawalAmount: 'Jumlah pengeluaran keseluruhan:',
    fee: 'Yuran:',
    withdrawalAmount: 'Jumlah Pengeluaran:',
    fundsSafeTitle: 'Dana anda selamat bersama kami',
    fundsSafeDesc: 'Kami menggunakan keselamatan terkemuka untuk melindungi transaksi dan maklumat peribadi anda.',
    enterWithdrawalAddress: 'Sila masukkan alamat pengeluaran',
    enterAccountNumberRequired: 'Sila masukkan nombor akaun anda',
    selectChannelRequired: 'Sila pilih saluran',
    enterAccountNameRequired: 'Sila masukkan nama pemilik akaun',
    selectPixKeyTypeRequired: 'Sila pilih jenis kunci PIX',
    enterCpfRequired: 'Sila masukkan CPF',
    enterValidAmount: 'Sila masukkan jumlah yang sah',
    minWithdrawal: 'Pengeluaran minimum: {amount} {unit}',
    maxWithdrawal: 'Pengeluaran maksimum: {amount} {unit}',
    insufficientBalance: 'Baki tersedia tidak mencukupi',
    withdrawalRejected: 'Pengeluaran ditolak',
    submittedPendingReview: 'Pengeluaran dihantar, menunggu semakan',
    submittedPayoutInProgress: 'Pengeluaran dihantar, pembayaran sedang diproses',
    withdrawalFailed: 'Pengeluaran gagal',
    withdrawalFailedRetry: 'Pengeluaran gagal, sila cuba lagi',
  },
};
